import { Plus, Edit, Trash2, Power, CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function EventsTab({ events, onCreateNew, onEdit, onDelete, onToggleStatus }) {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-heading font-bold uppercase text-primary">Gerenciar Eventos</h2>
        <Button
          data-testid="create-event-button"
          onClick={onCreateNew}
          className="bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-widest font-bold px-6 py-3 rounded-sm"
        >
          <Plus className="w-5 h-5 mr-2" />
          Novo Evento
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {events.map((event) => (
          <div key={event.id} data-testid={`event-${event.id}`} className={`bg-card border rounded-lg p-6 ${event.status === 'finished' ? 'border-gray-400 opacity-70' : 'border-border'}`}>
            <div className="flex justify-between items-start mb-2">
              <h3 className="text-xl font-heading font-bold uppercase text-primary">{event.name}</h3>
              {event.status === 'finished' && (
                <span className="text-xs bg-gray-500 text-white px-2 py-1 rounded uppercase font-bold">Encerrado</span>
              )}
              {event.status === 'active' && (
                <span className="text-xs bg-green-500 text-white px-2 py-1 rounded uppercase font-bold">Ativo</span>
              )}
            </div>
            <p className="text-sm text-foreground/70 mb-4">{event.location}</p>
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2">
                <Button
                  data-testid={`edit-event-${event.id}`}
                  size="sm"
                  variant="outline"
                  onClick={() => onEdit(event)}
                  className="flex-1 rounded-sm"
                >
                  <Edit className="w-4 h-4 mr-2" />
                  Editar
                </Button>
                <Button
                  data-testid={`delete-event-${event.id}`}
                  size="sm"
                  variant="destructive"
                  onClick={() => onDelete(event.id)}
                  className="flex-1 rounded-sm"
                >
                  <Trash2 className="w-4 h-4 mr-2" />
                  Excluir
                </Button>
              </div>
              <Button
                data-testid={`toggle-status-${event.id}`}
                size="sm"
                variant={event.status === 'active' ? 'outline' : 'default'}
                onClick={() => onToggleStatus(event)}
                className={`w-full rounded-sm ${event.status === 'active' ? 'border-orange-500 text-orange-600 hover:bg-orange-50' : 'bg-green-600 hover:bg-green-700 text-white'}`}
              >
                {event.status === 'active' ? (
                  <>
                    <Power className="w-4 h-4 mr-2" />
                    Encerrar Evento
                  </>
                ) : (
                  <>
                    <CheckCircle className="w-4 h-4 mr-2" />
                    Reativar Evento
                  </>
                )}
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
